export function MongolTrade({ traderCount }) {
	//TODO Rework this to show the stone commerce and improved version aswell
	//Should also programmatically show resources so that a stone and a stone with a + or something can be shown
	//Silkroad: 205556
	//Improved : 205810

	let icon =
		traderCount >= 15
			? '/liveGameIcons/unique/mongols/trade_gold.png'
			: traderCount >= 10
				? '/liveGameIcons/unique/mongols/trade_wood.png'
				: traderCount >= 5
					? '/liveGameIcons/unique/mongols/trade_food.png'
					: null

	return (
		<div
			className={`border-solid border flex flex-row justify-center w-[84px] h-[40px]`}
			style={{
				borderColor: 'var(--main-color)',
				backgroundImage: 'url("/sheepCounter/background.png")',
			}}
		>
			<div className="w-40px text-white flex flex-row items-center">
				+10%
			</div>

			<div className="h-[38px] w-[38px]">
				<img src={icon} className="" alt="" />
			</div>
		</div>
	)
}
